import "mobx-react-lite/batchingForReactDom";
import React from "react";
import { render } from "react-dom";
import { MainView } from "./views/mainView";

render(<MainView />, document.getElementById("root"));

